/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/8/13
 * Time: 1:19 PM
 * To change this template use File | Settings | File Templates.
 *
 * standard backbone collection
 */
define(function (require) {
    "use strict";

    var BaseCollection = require("collections/BaseCollection");

    var SingleSelectItemsCollection = BaseCollection.extend({});

    return SingleSelectItemsCollection;
});